import React from 'react';
import styles from './LogisticProductInfo.scss';
import { Icon } from '@/Components/Icon/Icon';
import { Icons } from '@/Static/IconsRes';
import {
  useLogisticProductIcons,
  useShippingServiceIcons,
} from '../LogisticProductSelect/hooks/useLogisticProductSelectIcons';
import { OrderAutomatizationProductModel } from '@/Models/OrderUserProducts/OrderAutomatizationProductModel';
import { getIconClasses } from '@/Static/IconUtils';
import cn from 'classnames';

type Props = {
  product: OrderAutomatizationProductModel;
  currency: string;
  onDelete: () => void;
};

export const LogisticProductInfo = ({ product, currency, onDelete }: Props) => {
  const { getLogisticProductIconByType } = useLogisticProductIcons();
  const { getShippingServiceIconByType } = useShippingServiceIcons();

  return (
    <div className={styles.logisticProduct}>
      <div className={styles.logisticType} title={product.productTypeName}>
        <Icon src={getLogisticProductIconByType(product.logisticTypeId)} alt={'error'} />
        <div>{product.productTypeName}</div>
      </div>
      <div className={styles.shippingFrom}>
        <Icon src={getShippingServiceIconByType(product.shippingServiceType)[0].icon} alt={'shipping'} />
        <div>{getShippingServiceIconByType(product.shippingServiceType)[0].type}</div>
      </div>
      <div className={styles.shippingTo}>
        <Icon src={getShippingServiceIconByType(product.shippingServiceType)[1].icon} alt={'shipping'} />
        <div>{getShippingServiceIconByType(product.shippingServiceType)[1].type}</div>
      </div>
      <div className={styles.shippingPrice}>
        {product.userProductPrice} {currency}
      </div>
      <div className={styles.shippingAction}>
        <Icon src={Icons.Cancel} alt={'delete'} onClick={onDelete} className={cn(getIconClasses('large'))} />
      </div>
    </div>
  );
};
